import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { RelatedPosition } from '~/constants/enum';
import { QUERY_RELATED_PRODUCT_BY_SKUS } from '~/data/home';

type ProductRelatedBySkusProps = {
    ruleId?: any;
    limit?: number;
    sku?: string;
    position?: RelatedPosition;
    skip?: boolean;
};

const useProductRelatedBySkus = ({
    limit,
    ruleId,
    sku,
    position = RelatedPosition.HomePage,
    skip = false
}: ProductRelatedBySkusProps) => {
    const queryProductRelated = useQuery(QUERY_RELATED_PRODUCT_BY_SKUS, {
        variables: {
            ruleId: Number(ruleId),
            limit,
            sku
        },

        skip: !!skip || Number.isNaN(Number(ruleId)),

        context: { fetchOptions: { method: 'GET' } }
    });

    const dataByPosition = useMemo(() => {
        const blockPosition = queryProductRelated.data?.relatedProductsBySkus?.block_position;
        const items = queryProductRelated.data?.relatedProductsBySkus?.items;
        if (blockPosition !== position) {
            return [];
        }
        return items;
    }, [queryProductRelated.data?.relatedProductsBySkus]);
    return {
        ...queryProductRelated,
        relatedProductsBySkus: queryProductRelated.data?.relatedProductsBySkus,
        products: dataByPosition
    };
};

export default useProductRelatedBySkus;
